export default "__VITE_ASSET__Dx8NFPpI__"